<template>
  <div id="sys-wrapper" >
    <!--begin --- header ---begin  -->
    <div class="h-title-con">
      <div class="h-title">
        <span class="title-text"><span class="title-tip"></span>{{ruleForm.id? '编辑':'新增'}}组织</span>
      </div>
      <div class="h-button-warpper">
        <el-button size="small" @click="save" type="primary"><i  class="iconfont icon-baocun"></i>保存</el-button>
        <el-button size="small" @click="back" type="primary"><i class="iconfont icon-fanhui"></i>取消</el-button>
      </div>
    </div>
    <!--end --- header ---end  -->
    <!--begin --- content ---begin  -->
    <div class="white-bg-radius sys-content w-label" style="padding-top: 20px;padding-left: 20px">
      <!--<el-card class="box-card"  >-->
        <el-form :model="ruleForm" :rules="rules" ref="form"
                 label-position="right" label-width="180px"  class="demo-ruleForm" size="mini">
          <h2 class="bt-title">组织信息</h2>
          <el-form-item label="上级组织：" prop="organization" class="ww-input-dia">
            <el-input v-model="ruleForm.organization" placeholder="请输入上级组织"
            @focus="openDialog"
            suffix-icon="el-icon-tickets"
            :disabled="isUpdate"
             readonly>
             <i v-if="!isUpdate"  class="el-icon-error"  slot="append" @click.stop.prevent="clear()" ></i>
            </el-input>
          </el-form-item>
          <el-form-item label="组织编码：" prop="organizeCode">
            <el-input v-model="ruleForm.organizeCode" placeholder="请输入组织编码"></el-input>
          </el-form-item>
          <el-form-item label="组织名称：" prop="organizeName">
            <el-input v-model="ruleForm.organizeName" placeholder="请输入组织名称"></el-input>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input v-model="ruleForm.remark" placeholder="请输入"></el-input>
          </el-form-item>
          <!--<el-form-item label="负责人" prop="roleSelection" class="ww-input-dia">
            <el-input v-model="ruleForm.roleSelection" placeholder="请输入负责人"
            @focus="openDialog"
              suffix-icon="el-icon-tickets"
              :disabled="isUpdate"
              readonly>
               <i  class="el-icon-error"  slot="append" @click.stop.prevent="clear()"></i>
            </el-input>
          </el-form-item>-->
          <el-form-item label="状态：" prop="status">
            <el-radio-group v-model="ruleForm.status">
              <el-radio v-for=" (item,index) in statusList" :key="index" :label="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>

        </el-form>
      <!--</el-card>-->
    </div>
    <tabel-dialog
      ref="dlg"
      :dialog-visible="showTabelFlag"
      @close="close"
      @confirm-select-item="setSelectItem" >
      </tabel-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import commonMixin from '@/mixins/common.js';
  import checkboxDialog from "../components/checkbox-dialog.vue";
  import tabelDialog from "../organizationManagement/tabel-dialog.vue";
  import { methodPost, methodGet } from "../../api/request.js";
  export default {
    name: 'addOrganization',
    mixins: [commonMixin],
    components: { checkboxDialog, tabelDialog },
    data() {
      return {
        isUpdate: false,
        showDialogFlag: false,
        showTabelFlag: false,
        statusList: [
          { label: '有效', value: 1 },
          { label: '无效', value: 0 }
        ],
        ruleForm: {
          id: '',
          parentId: '',
          organizeCode: '', // 所属组织
          organizeName: '', // 员工编号
          upOrganizeValue: '', // 员工姓名上级组织
          staffName: '', // 负责人
          remark: '', // 备注
          status: 1 }, // 是否启用
        rules: {
          organizeCode: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          organizeName: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          status: [
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      back(isRefresh) {
        const path = '/organizationManagement/index'
        this.goBack(path)
        if (isRefresh) {
          this.$nextTick(() => {
            this.$eventBus.$emit('refresh-custom-table')
          })
        }
      },
      clear() {
        this.ruleForm.organization = '';
      },
      save() {
        this.$refs.form.validate(valid => {
          console.log(valid)
          if (valid) {
            this.submitForm()
          } else {
            console.log('error submit!!')
          }
        })
      },
      submitForm() {
        let URL
        if (this.ruleForm.id) {
          URL = '/sysOrganize/modifyOrganize'
        } else {
          URL = '/sysOrganize/saveOrganize'
        }
        if (!this.ruleForm.organization) {
          this.ruleForm.parentId = '0'
        }
        const params = {
          id: this.ruleForm.id,
          parentId: this.ruleForm.parentId,
          upOrganizeCode: this.ruleForm.upOrganizeCode,
          upOrganizeName: this.ruleForm.upOrganizeName,
          organizeCode: this.ruleForm.organizeCode,
          organizeName: this.ruleForm.organizeName,
          staffName: this.ruleForm.staffName,
          remark: this.ruleForm.remark,
          status: this.ruleForm.status
        }
        methodPost(URL, params).then(res => {
          if (res.code === 0) {
            this.$message.success(`${this.ruleForm.id ? '保存' : '新增'}成功`)
            this.back(true)
          } else {
            this.$message.error(res.message || '保存出错，请稍后再试')
          }
        })
      },
      // 关闭弹框
      cancel() {
        this.showDialogFlag = false;
      },
      close() {
        this.showTabelFlag = false;
      },
      // 出现弹框里边的方法
      setSelectItem(val) {
        this.showDialogFlag = false;
        this.showTabelFlag = false;
      },
      openDialog() {
        this.showTabelFlag = true;
        this.$refs.dlg.open({
          dlgTitle: '上级组织',
          url: '/sysOrganize/findSysParentOrganizeList',
          emptyMessage: '请选择上级组织',
          tableColumns: [
            { name: 'organizeName', label: '组织名称' },
            { name: 'organizeCode', label: '组织编码' }
          ],
          selectId: this.ruleForm.parentId,
          placeholder: '请输入客户名称或客户代号',
          idField: 'id'
        }).then(item => {
          this.ruleForm.organization = item.organizeName;
          this.ruleForm.parentId = item.id;
          this.showTabelFlag = false;
        })
      },
      editEvent(val) {
        methodGet('/sysOrganize/getOrganizeById/' + val).then(res => {
          if (res.code === 0) {
            this.ruleForm.organizeCode = res.data.organizeCode;
            this.ruleForm.organizeName = res.data.organizeName;
            this.ruleForm.organization = res.data.upOrganizeName;
            this.ruleForm.id = res.data.id;
            this.ruleForm.remark = res.data.remark
            this.ruleForm.status = res.data.status
            this.ruleForm.parentId = res.data.parentId
            if (this.ruleForm.parentId === 0) {
              this.isUpdate = true;
            }
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    computed: {
      ...mapGetters([
        'sidebar'
      ])
    },
    mounted() {
      if (this.$route.query.id) {
        this.editEvent(this.$route.query.id)
      }
    }

  }
</script>

<style lang="scss">
  #sys-wrapper {
    position: relative;
    .sys-content {
      .bt-title{
        border-bottom:1px solid #eee;
        height:30px;
        font-size:14px;
        color:#333;
        margin-bottom:20px;
      }
      .el-form-item__label {
        padding-right: 5px !important;
      }
      .el-form-item__error{
        left: 105%;
        width: 200px;
        top: 25%;
      }
      .el-form-item{
        margin-bottom: 10px;
      }

    }
    .sys-footer{
      position: absolute;
      bottom: 0px;
      left: 0px;
      margin-left: 20px;
      height: 60px;
      width: 100%;
    }
    .content-params {
      padding:5px 20px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      overflow: hidden;
      .params {
        min-width:340px;
        margin: 5px 0;
        font-size: 0;
      }
      .custom_label {
        min-width: 80px;
        display:inline-block;
        font-size: 14px;
        font-weight:700;
        text-align: right;
        color:#606266;
        i {
          color: red;
          font-style: normal;
          vertical-align: middle;
        }
      }
    }
}

</style>
<style>
#app .el-card.box-card.is-always-shadow{
  -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,0);
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0);
}
#app .el-card.box-card{
  border:0;
  border-radius:0;
}
#app .el-input--mini .el-input__inner {
    height: 22px;
    line-height: 22px;
}
.params .el-input{
    width:210px!important;
  }
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/organizationManagement/add.vue